module.exports = __webpack_public_path__ + "static/driver-mockup-ff79187de80660e3bbaab96314df37a7.png";